<template>
  <div :class="['info-box', colorClass]">
    <span class="info-box-icon">
      <i :class="iconClasses"></i>
    </span>
    <div class="info-box-content">
      <span class="info-box-text">{{text}}</span>
      <span class="info-box-text">{{number}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SmallBox',
    props: {
      text: {
        type: String,
        required: true
      },
      number: {
        type: String,
        default: 0
      },
      iconClasses: {
        type: Array,
        default: []
      },
      colorClass: {
        type: String,
        default: 'bg-default'
      }
    }
  }
</script>
<style>
  #notFound {
    padding: 10em;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// SmallBox.vue?f3fca93c